import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b4d83f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "modal__content" }
const _hoisted_3 = { class: "modal__inner__content tw-w-full" }
const _hoisted_4 = { class: "input_field email_address" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Email Addresses", -1))
const _hoisted_6 = {
  key: 0,
  class: "input_field tags_wrapper"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Tags", -1))
const _hoisted_8 = { class: "input_field message_wrapper" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Message (optional):", -1))
const _hoisted_10 = { class: "modal__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InvitationSuccessComponent = _resolveComponent("InvitationSuccessComponent")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox_btn = _resolveComponent("v-checkbox-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_Button = _resolveComponent("Button")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_CommonDialog = _resolveComponent("CommonDialog")!

  return ($setup.isShowInvitationsSentModal)
    ? (_openBlock(), _createBlock(_component_InvitationSuccessComponent, {
        key: 0,
        onOnClose: $setup.onClickCloseButton,
        members: $setup.form.members
      }, null, 8, ["onOnClose", "members"]))
    : (_openBlock(), _createBlock(_component_CommonDialog, {
        key: 1,
        isShowHeader: false,
        isShowBackButton: false,
        className: ['add_contractor_dialog'],
        width: "700px",
        "max-width": "100%"
      }, {
        body: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h4", null, " Invite a " + _toDisplayString($setup.isClientModule ? "clients" : "contractor") + " to iknowa platform ", 1),
            _createVNode(_component_v_btn, {
              icon: "mdi-close",
              onClick: $setup.onClickCloseButton
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_v_form, {
                ref: "emailFormRef",
                onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
                class: "tw-w-full"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.form.members, (member, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: _normalizeClass(["tw-w-full invite_members_form", { 'no-tags': !$props.isShowTag }])
                    }, [
                      _createElementVNode("div", _hoisted_4, [
                        _hoisted_5,
                        _createVNode(_component_v_text_field, {
                          type: "email",
                          density: "compact",
                          modelValue: member.email,
                          "onUpdate:modelValue": ($event: any) => ((member.email) = $event),
                          rules: $setup.validation.email,
                          variant: "outlined",
                          class: "c-input",
                          placeholder: "Email address"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                      ]),
                      ($props.isShowTag)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _hoisted_7,
                            _createVNode(_component_v_select, {
                              class: "c-select",
                              modelValue: member.tags,
                              "onUpdate:modelValue": ($event: any) => ((member.tags) = $event),
                              items: $setup.Tags,
                              rules: $setup.validation.tags,
                              placeholder: "Select Tags",
                              multiple: "",
                              variant: "outlined",
                              "menu-props": { contentClass: 'tags_dropdown' },
                              menu: false
                            }, {
                              "prepend-item": _withCtx(() => [
                                _createVNode(_component_v_list_item, {
                                  title: "Select All",
                                  onClick: ($event: any) => ($setup.toggle(member)),
                                  class: "list__item"
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_v_checkbox_btn, {
                                      color: 
                            $setup.likesSomeTag(member) ? 'indigo-darken-4' : undefined
                          ,
                                      indeterminate: 
                            $setup.likesSomeTag(member) && !$setup.likesAllTags(member)
                          ,
                                      "model-value": $setup.likesAllTags(member)
                                    }, null, 8, ["color", "indeterminate", "model-value"])
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              "append-item": _withCtx(() => [
                                _createVNode(_component_v_list_item, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      modelValue: $setup.customTag,
                                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.customTag) = $event)),
                                      label: "Add custom tag",
                                      variant: "outlined",
                                      class: "inner_input"
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_v_btn, {
                                      onClick: ($event: any) => ($setup.addCustomTag(member)),
                                      class: "button button-orange"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Add")
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue", "items", "rules"])
                          ]))
                        : _createCommentVNode("", true),
                      ($setup.form.members.length > 1)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 1,
                            icon: "mdi-close",
                            onClick: ($event: any) => ($setup.onRemoveEmail(index)),
                            class: "remove_btn",
                            variant: "plain"
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ], 2))
                  }), 128)),
                  _createVNode(_component_Button, {
                    variant: "accent",
                    label: "+ADD",
                    class: "add_btn !tw-w-auto",
                    onClick: $setup.onAddEmail
                  }, null, 8, ["onClick"]),
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode(_component_v_textarea, {
                      modelValue: $setup.memberMessage,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.memberMessage) = $event)),
                      variant: "outlined"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              }, 512)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_v_btn, {
              class: "button button-purple-border",
              onClick: $setup.onClickCloseButton
            }, {
              default: _withCtx(() => [
                _createTextVNode("cancel")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_Button, {
              label: "SEND INVITATION",
              variant: "accent",
              class: "button !tw-w-auto",
              onClick: $setup.onSendInvitation,
              isLoading: $setup.isShowLoadingSendInvitation,
              isActive: $setup.isFormValid && $setup.hasAtLeastOneMember
            }, null, 8, ["onClick", "isLoading", "isActive"])
          ])
        ]),
        _: 1
      }))
}